import type { FaireProductEntity } from "../../entity_types/product";

export const p_fmp59xpqza: FaireProductEntity = {
  token: "p_fmp59xpqza",
  type: "product",
  name: "Evil Eye Keychain Bag Charm",
  brandToken: "b_6hzxpxjqta",
  brandName: "Sparkling Extras",
  imageUrl:
    "https://cdn.faire.com/fastly/9686804a43c7ab228368f6620004f746617fe1002ff97d82925cafa991143d52.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cf8138110b975f156862bc71cba2536776a1e851bc5e5a84b05bd5c49e348322.jpeg",
    "https://cdn.faire.com/fastly/36bc9182d89ee7617f7c380d29265fbd599f8fed4c90ad0f30497b11f40db921.jpeg",
    "https://cdn.faire.com/fastly/927f043b136d9280bf88a84a9438668f9bcf712406f758258362284099692c29.jpeg",
  ],
  priceDollars: 6.91,
  description:
    "Material: Alloy, Resin\nIt is a stylish and meaningful accessory that combines fashion with ancient symbolism. Designed to ward off negative energy and bring good luck, this charm features the iconic evil eye symbol—often depicted as a blue and white eye—that has been used for centuries across various cultures as a protective talisman.",
  tags: [],
  msrpDollars: 13.83,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:08.067Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
